/* eslint-disable react/static-property-placement */
import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, Pages, Categories, Options } from './styled';

export default class Content extends React.PureComponent {
    static propTypes = {
        handleClick: PropTypes.func,
        className: PropTypes.string,
        categories: PropTypes.arrayOf(PropTypes.object),
        b2cRedirectionModal: PropTypes.shape({
            openModal: PropTypes.func,
            closeModal: PropTypes.func,
        }),
    };

    static defaultProps = {
        handleClick: () => {},
        className: '',
        categories: {},
        b2cRedirectionModal: {},
    };

    handleClickOutside() {
        const { handleClick } = this.props;
        handleClick();
    }

    render() {
        const { className, categories, handleClick, b2cRedirectionModal } = this.props;
        return (
            <Wrap className={className}>
                <Pages closeMenu={handleClick} b2cRedirectionModal={b2cRedirectionModal} />
                <Categories categories={categories} closeMenu={handleClick} />
                <Options closeMenu={handleClick} />
            </Wrap>
        );
    }
}
